export enum PopupMessagesEnum {
  SkipUpdatePlaylist = 'You\'ll lose all changes. Press the "Finish" button for saving.',
}
